// extracted by mini-css-extract-plugin
module.exports = {"rootStyles":"_2BVIx","root":"yBJuM","border":"_3_X_x"};